import React, { useState, useEffect } from 'react';
import { useAuth } from '../App';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { toast } from 'sonner';
import { LogOut, ArrowLeft, Calendar, User, Eye } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;

const ManagerHSOffresEnCours = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeOffers, setActiveOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchActiveOffers();
  }, []);

  const fetchActiveOffers = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API}/job-offers`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const offers = await response.json();
        // Filter active offers for Horizon Solution only
        const active = offers.filter(offer => 
          offer.status === 'en_cours' && offer.company === 'Horizon Solution'
        );
        setActiveOffers(active);
      } else {
        toast.error('Erreur lors du chargement des offres en cours');
      }
    } catch (error) {
      console.error('Error fetching active offers:', error);
      toast.error('Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    toast.success('Déconnexion réussie');
  };

  const handleBackToManagerHS = () => {
    navigate('/manager-horizon');
  };

  const handleOfferClick = (offer) => {
    navigate(`/manager-hs/offer-detail/${offer.id}`);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Non spécifiée';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const companyLogos = {
    'Horizon Solution': 'https://customer-assets.emergentagent.com/job_a2d904ae-21ae-408b-b651-ff0f492712a1/artifacts/md0676vy_Design%20sans%20titre%20%282%29.png'
  };

  return (
    <div className="manager-hs-offres-cours-page">
      {/* Header */}
      <header className="rh-header">
        <div className="flex items-center space-x-4">
          <Button
            onClick={handleBackToManagerHS}
            variant="outline"
            size="sm"
            className="btn-outline"
            style={{ borderColor: '#eb5d2d', color: '#eb5d2d' }}
          >
            <ArrowLeft size={16} className="mr-2" />
            Retour
          </Button>
          <img
            src={companyLogos['Horizon Solution']}
            alt="Logo Horizon Solution"
            className="rh-header-logo"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
        <h1>Offres en cours - Horizon Solution</h1>
        <Button
          onClick={handleLogout}
          variant="outline"
          size="sm"
          className="btn-outline"
          style={{ borderColor: '#eb5d2d', color: '#eb5d2d' }}
        >
          <LogOut size={16} className="mr-2" />
          Déconnexion
        </Button>
      </header>

      {/* Main Content */}
      <main className="rh-main">
        <div className="offers-header">
          <h2>Offres en cours ({activeOffers.length})</h2>
          <p>Gérez vos offres d'emploi actives et leurs candidatures</p>
        </div>

        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
          </div>
        ) : (
          <div className="recruitment-grid-compact">
            {activeOffers.map((offer) => (
              <Card 
                key={offer.id}
                className="recruitment-card-compact cursor-pointer group"
                onClick={() => handleOfferClick(offer)}
              >
                <CardContent className="recruitment-card-compact-content">
                  <div className="recruitment-card-compact-header">
                    <img
                      src={companyLogos['Horizon Solution']}
                      alt="Logo Horizon Solution"
                      className="recruitment-card-compact-logo"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                    <Eye className="recruitment-card-compact-icon" />
                  </div>
                  <h3 className="recruitment-card-compact-title">
                    {offer.title}
                  </h3>
                  <div className="recruitment-card-compact-info">
                    <div className="recruitment-card-compact-info-item">
                      <User size={14} />
                      <span><strong>Manager :</strong> {offer.creator_name || 'Non spécifié'}</span>
                    </div>
                    <div className="recruitment-card-compact-info-item">
                      <Calendar size={14} />
                      <span><strong>Date idéale :</strong> {formatDate(offer.date_arrivee)}</span>
                    </div>
                    {offer.type_poste && (
                      <div className="recruitment-card-compact-info-item">
                        <span><strong>Type :</strong> {offer.type_poste}</span>
                      </div>
                    )}
                    {offer.taux_horaire && (
                      <div className="recruitment-card-compact-info-item">
                        <span><strong>Taux :</strong> {offer.taux_horaire}€/h</span>
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            ))}
            {activeOffers.length === 0 && !loading && (
              <div className="empty-state-compact">
                <p>Aucune offre en cours</p>
              </div>
            )}
          </div>
        )}
      </main>
    </div>
  );
};

export default ManagerHSOffresEnCours;